// @flow
import * as React from 'react';

import { formatPhoneNumber } from 'utils/string';
import TextField, {
  type Props as TextFieldProps
} from '../../components/TextField/TextField';

export type Props = {
  /**
   * The country code to use when doing the format
   */
  countryCode: string,
  /**
   * Callback invoked when the input changes
   */
  onChange?: (event: SyntheticInputEvent<HTMLInputElement>) => void
} & TextFieldProps;

type State = {
  value: string,
  rawValue: string
};

type Properties = {
  /**
   * Format result
   */
  result: string
};

export default class PhoneTextField extends React.Component<Props, State> {
  static block = 'phone-text-field';

  constructor(props: Props) {
    super(props);
    const initialValue = props.value || props.defaultValue || '';
    this.state = {
      rawValue: this.getRawValue(initialValue),
      value: this.format(initialValue)
    };
    this.properties = { result: this.state.value };
  }

  properties: Properties;

  /**
   * Formats a value using google's libphonumber library
   */
  format(value?: string) {
    if (!value) {
      return '';
    }
    const { countryCode } = this.props;
    return formatPhoneNumber(value, countryCode);
  }

  /**
   * Strips any invalid chars from the input (only 0-9 chars are kept)
   */
  getRawValue(value?: string = '') {
    let result = value;
    // only keep number and +
    result = result.replace(/[^\d+]/g, '');
    // strip non-leading +
    result = result
      .replace(/^\+/, 'B')
      .replace(/\+/g, '')
      .replace('B', '+');
    return result;
  }

  onInput = (event: SyntheticInputEvent<HTMLInputElement>) => {
    const rawValue = this.getRawValue(event.target.value);
    const value = this.format(rawValue);
    this.properties.result = value;
    this.setState({
      rawValue,
      value
    });
  };

  onChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    const { onChange } = this.props;
    // populates this.properties.result
    this.onInput(event);
    (event.target: any).rawValue = this.getRawValue(this.properties.result);
    event.target.value = this.properties.result;
    if (onChange) {
      onChange(event);
    }
  };

  render() {
    const {
      value,
      defaultValue,
      countryCode,
      onChange,
      ...textFieldProps
    } = this.props;
    const additionalProps = {};

    // attempt to simulate a controlled component
    if (!('defaultValue' in this.props)) {
      if ('value' in this.props) {
        additionalProps.value = this.format(value);
      } else {
        additionalProps.value = this.state.value;
      }
    } else {
      additionalProps.defaultValue = this.format(defaultValue);
    }

    return (
      <TextField
        className={PhoneTextField.block}
        onChange={this.onChange}
        onInput={this.onInput}
        {...additionalProps}
        {...textFieldProps}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/api/containers/PhoneTextField/PhoneTextField.js